import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { User } from 'lucide-react';

import { AuthHelper } from '../../helpers/auth.helper';

import { getUserData } from '../../store/misc.slice';

import { useSignout } from '../../hooks/auth-ux';

import { LogoPackageHoriz } from './LogoPackage';
import { OutsideAlerter } from '../utilities/OutsideAlerter';

export const Navbar = () => {
    const navigate = useNavigate();

    const userData = useSelector(getUserData());

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const { mutate: signout } = useSignout();

    const goToPage = (route: string) => {
        setIsDropdownOpen(false);
        navigate(route);
    };

    return (
        <div className='navbar'>
            <div className='navbar__content'>
                <Link to="/"><LogoPackageHoriz /></Link>
                <div className="navbar__right">
                    {(userData || AuthHelper.isGuestTokenValid().result) &&
                        <Fragment>
                            {
                                !userData
                                    ? <div className='navbar__guest_data'>
                                        <User />
                                        <p className='text-sm text-medium'>Guest user</p>
                                    </div>
                                    : <div className='navbar__user_data'>
                                        <button className='navbar__user_data__main_btn' onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                                            {userData.email
                                                ? <p className='text-sm text-medium'>{userData.email[0].toUpperCase()}</p>
                                                : userData.username
                                                    ? <p className='text-sm text-medium'>{userData.username[0].toUpperCase()}</p>
                                                    : <User />
                                            }
                                        </button>
                                        <OutsideAlerter isActive={isDropdownOpen} callback={() => setIsDropdownOpen(false)}>
                                            <div className={`navbar__user_data__dropdown ${isDropdownOpen ? 'navbar__user_data__dropdown--open' : ''}`}>
                                                <div className='navbar__user_data__dropdown__menu'>
                                                    <button onClick={() => goToPage('/report-history')} disabled>Report History</button>
                                                    <button onClick={() => goToPage('/settings')} disabled>Settings</button>
                                                    <button onClick={() => signout()}>Log out</button>
                                                </div>
                                            </div>
                                        </OutsideAlerter>
                                    </div>
                            }
                        </Fragment>
                    }
                    {!userData && (AuthHelper.isSessionTokenValid().result || AuthHelper.isGuestTokenValid().result) &&
                        <button
                            className='navbar__sign_in_btn'
                            onClick={() => navigate('/auth')}
                        >
                            <div>
                                <User />
                            </div>
                            <p>Sign In</p>
                        </button>
                    }
                </div>
            </div>
        </div>
    );
};